// extracted by mini-css-extract-plugin
export default {"wrapper":"t2pS5","title":"_daKF","body":"YkKnV","navigation":"REIAG","dialog":"k0s7w","button":"ovsnP"};